// Mensagem e detecção do erro SEM_QUINZENA, lançado pelo servidor (409) quando se tenta
// registrar ou mover uma tarefa para uma data sem quinzena ABERTA cobrindo-a.
// O apiRequest lança Error("409: <body>"), então basta procurar o code no texto.
export const SEM_QUINZENA_MSG =
  "Antes de registrar uma nova Tarefa, crie a quinzena atual no Financeiro.";

export function isSemQuinzena(err: unknown): boolean {
  return err instanceof Error && err.message.includes("SEM_QUINZENA");
}
